import { plainToClass } from "class-transformer";
import { TableColumnVisibilityController, TableColumnGroup } from "../../../../shared/scripts/table-column-visibility";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";

export class SettingsPicklists {
    private picklistMap: { [key: string]: { tableId: string, addBtnId: string, data: any[], timeSpan: boolean } } = {
        'actionItemCriticalTypes': { tableId: '#action-item-critical-table', addBtnId: '#add-action-item-critical-btn', data: [], timeSpan: false },
        'actionItemStatuses': { tableId: '#action-item-status-table', addBtnId: '#add-action-item-status-btn', data: [], timeSpan: false },
        'actionItemTypes': { tableId: '#action-item-type-table', addBtnId: '#add-action-item-type-btn', data: [], timeSpan: false },
        'attachmentTypes': { tableId: '#attachment-type-table', addBtnId: '#add-attachment-type-btn', data: [], timeSpan: false },
        'communicationStatuses': { tableId: '#communication-status-table', addBtnId: '#add-communication-status-btn', data: [], timeSpan: false },
        'communicationTopics': { tableId: '#communication-topic-table', addBtnId: '#add-communication-topic-btn', data: [], timeSpan: false },
        'communicationTypes': { tableId: '#communication-type-table', addBtnId: '#add-communication-type-btn', data: [], timeSpan: false },
        'jobFunctions': { tableId: '#job-function-table', addBtnId: '#add-job-function-btn', data: [], timeSpan: false },
        'deliverables': { tableId: '#deliverable-table', addBtnId: '#add-deliverable-btn', data: [], timeSpan: false },
        'milestones': { tableId: '#milestone-table', addBtnId: '#add-milestone-btn', data: [], timeSpan: true },
        'addressTypes': { tableId: '#address-type-table', addBtnId: '#add-address-type-btn', data: [], timeSpan: false },
        'deliverableStatuses': { tableId: '#deliverable-status-table', addBtnId: '#add-deliverable-status-btn', data: [], timeSpan: false },
        'studyStatuses': { tableId: '#study-status-table', addBtnId: '#add-study-status-btn', data: [], timeSpan: false }
    };
    private token: string;
    private manageModalPicklistType: string = '';
    private manageModalData: any[] = [];
    private manageModalTable: any = null;


    private isNonViewer: boolean;
    private isAdmin: boolean;

    constructor(picklistData: { [key: string]: any[] }, isNonViewer: boolean, isAdmin: boolean) {
        $(() => {
            this.isNonViewer = isNonViewer === true;
            this.isAdmin = isAdmin === true;
            this.token = document.querySelector('input[name="__RequestVerificationToken"]').getAttribute('value');
            this.loadPicklistData(picklistData);
            this.initPicklistTables();
            this.initModalHandlers();
            this.initManageItemsHandlers();
            //Since we're taking more of a programmatic approach here, programmatically adjust columns when tab is shown instead of manually like what was done for communications dialog
            $('#listTabSection .ctms-st-menu a[data-toggle="tab"]').on('shown.bs.tab', (e) => {
                const tabId = $(e.target).attr('href');
                for (const key in this.picklistMap) {
                    if (!this.picklistMap.hasOwnProperty(key)) continue;
                    const { tableId } = this.picklistMap[key];
                    if ($(tabId).find(tableId).length > 0) {
                        const table = $(tableId).DataTable();
                        table.columns.adjust();
                        break;
                    }
                }
            });
        });
    }

    private loadPicklistData(picklistData: { [key: string]: any[] }) {
        for (const key in this.picklistMap) {
            if (this.picklistMap.hasOwnProperty(key) && picklistData[key]) {
                this.picklistMap[key].data = picklistData[key];
            }
        }
    }

    private initPicklistTables() {
        const self = this;
        //Set up the datatables for the main picklist tables
        for (const key in this.picklistMap) {
            if (!this.picklistMap.hasOwnProperty(key)) continue;
            const { tableId, addBtnId, data } = this.picklistMap[key];
            // We only want to show non-archived picklist items
            const nonArchivedData = Array.isArray(data) ? data.filter(item => !item.IsArchived) : [];
            const $table = $(tableId);
            $table.DataTable({
                dom: 'rtip',
                autoWidth: false,
                info: false,
                paging: false,
                search: true,
                scrollX: true,
                scrollY: '30vh',
                scrollCollapse: true,
                orderCellsTop: true,
                order: [[0, 'asc']],
                columns: [
                    { data: "SortById", title: "SortById", visible: false, orderable: true },
                    { data: 'Name', title: 'Name', orderable: false },
                    {
                        data: null,
                        title: '',
                        className: 'ctms-table-col-actions',
                        orderable: false,
                        render: function (data, type, row) {
                            if (self.isAdmin) {
                                return `<button class="ctms-action-edit" title="Edit"><i class="ctms-icon-pencil"></i></button>`;
                            }
                            else {
                                return '';
                            }
                        }
                    }
                ],
                data: nonArchivedData
            });
            $table.on('click', '.ctms-action-edit', (evt) => {
                const row = $(evt.target).closest('tr');
                const rowData = $table.DataTable().row(row).data();
                this.openModal(key, rowData);
            });
            $(addBtnId).on('click', () => {
                this.openModal(key, null);
            });
        }
    }

    private initManageItemsHandlers() {
        const manageBtnMap = {
            'actionItemCriticalTypes': '#manage-action-item-critical-btn',
            'actionItemStatuses': '#manage-action-item-status-btn',
            'actionItemTypes': '#manage-action-item-type-btn',
            'attachmentTypes': '#manage-attachment-type-btn',
            'communicationStatuses': '#manage-communication-status-btn',
            'communicationTopics': '#manage-communication-topic-btn',
            'communicationTypes': '#manage-communication-type-btn',
            'jobFunctions': '#manage-job-function-btn',
            'deliverables': '#manage-deliverable-btn',
            'milestones': '#manage-milestone-btn',
            'addressTypes': '#manage-address-type-btn',
            'deliverableStatuses': '#manage-deliverable-status-btn',
            'studyStatuses': '#manage-study-status-btn'
        };
        for (const key in manageBtnMap) {
            $(manageBtnMap[key]).on('click', () => {
                this.openManageItemsModal(key);
            });
        }
    }

    private moveNonArchivedItem(id: number, direction: number) {
        // Get all non-archived items sorted by SortById
        const nonArchived = this.manageModalData.filter(item => !item.IsArchived)
            .sort((a, b) => (a.SortById ?? 0) - (b.SortById ?? 0));
        const idx = nonArchived.findIndex(item => item.Id === id);
        if (idx === -1) return;
        const swapIdx = idx + direction;
        if (swapIdx < 0 || swapIdx >= nonArchived.length) return;
        // Swap SortById values
        const current = nonArchived[idx];
        const target = nonArchived[swapIdx];
        const tempOrder = current.SortById;
        current.SortById = target.SortById;
        target.SortById = tempOrder;
        this.updateSortById();
        this.manageModalTable.clear().rows.add(this.manageModalData).draw(false);
    }

    private openManageItemsModal(picklistType: string) {
        this.manageModalPicklistType = picklistType;
        // Deep clone the picklist data for modal editing
        const clonedData = JSON.parse(JSON.stringify(this.picklistMap[picklistType].data || []));
        // Split into non-archived and archived
        const nonArchived = clonedData.filter(item => !item.IsArchived);
        const archived = clonedData.filter(item => item.IsArchived);
        // Assign sequential SortById and sortkey to non-archived
        nonArchived.forEach((item, idx) => {
            item.sortkey = '0-' + String(item.SortById).padStart(4, '0');
        });
        // Assign sortkey to archived, Order is blank
        archived.forEach(item => {
            item.sortkey = '1-' + String(item.Name ?? '').toLowerCase();
        });
        // Combine for modal data
        this.manageModalData = [...nonArchived, ...archived];
        // Destroy previous table if exists
        if (this.manageModalTable) {
            this.manageModalTable.destroy();
            $('#manage-picklist-items-table').empty();
        }
        // Render DataTable
        this.manageModalTable = $('#manage-picklist-items-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '40vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: "sortkey", title: "sortkey", visible: false, orderable: true },
                {
                    data: 'SortById',
                    title: 'Order',
                    width: '120px',
                    orderable: false,
                    render: (data, type, row, meta) => {
                        if (!row.IsArchived) {
                            const nonArchivedCount = this.manageModalData.filter(x => !x.IsArchived).length;
                            var upBtn = row.SortById > 1 ? `<button class="ctms-move-up ctms-button mr-1" data-id="${row.Id}" title="Move Up">+</button>` : '';
                            var downBtn = row.SortById < nonArchivedCount ? `<button class="ctms-move-down ctms-button" data-id="${row.Id}" title="Move Down">-</button>` : '';
                            return `${upBtn}${downBtn}`;
                        }
                        return '';
                    }
                },
                { data: 'Name', title: 'Name', orderable: false, render: (data, type, row) => !row.IsArchived ? data : `<s>${data}</s>` },
                {
                    data: null,
                    title: '',
                    orderable: false,
                    render: (data, type, row, meta) => {
                        if (row.IsArchived) {
                            return `<button class="ctms-picklist-add ctms-button" data-row="${meta.row}" title="Add">Add</button>`;
                        } else {
                            return `<button class="ctms-picklist-remove ctms-button" data-row="${meta.row}" title="Remove">Remove</button>`;
                        }
                    }
                }
            ],
            data: this.manageModalData
        });
        $('#manage-picklist-items-table').off('click', '.ctms-move-up').on('click', '.ctms-move-up', (e) => {
            const id = Number($(e.target).data('id'));
            this.moveNonArchivedItem(id, -1);
        });
        $('#manage-picklist-items-table').off('click', '.ctms-move-down').on('click', '.ctms-move-down', (e) => {
            const id = Number($(e.target).data('id'));
            this.moveNonArchivedItem(id, 1);
        });
        $('#manage-picklist-items-table').off('click', '.ctms-picklist-add').on('click', '.ctms-picklist-add', (e) => {
            const idx = Number($(e.target).data('row'));
            this.manageModalData[idx].IsArchived = false;
            this.updateSortById();
            this.manageModalTable.clear().rows.add(this.manageModalData).draw(false);
        });
        $('#manage-picklist-items-table').off('click', '.ctms-picklist-remove').on('click', '.ctms-picklist-remove', (e) => {
            const idx = Number($(e.target).data('row'));
            this.manageModalData[idx].IsArchived = true;
            this.updateSortById();
            this.manageModalTable.clear().rows.add(this.manageModalData).draw(false);
        });
        $('#managePicklistItemsModal').modal({
            backdrop: 'static',
            show: true
        });
    }

    private updateSortById() {
        // Split into non-archived and archived...make sure we sort these before changing SortById since it's updating by index in the object array
        const nonArchived = this.manageModalData.filter(item => !item.IsArchived)
        .sort((a, b) => {
            if (a.SortById != null && b.SortById != null) return (a.SortById ?? 0) - (b.SortById ?? 0);
            return (a.Name ?? '').localeCompare(b.Name ?? '');
        });
        const archived = this.manageModalData.filter(item => item.IsArchived)
        .sort((a, b) => {
            if (a.SortById != null && b.SortById != null) return (a.SortById ?? 0) - (b.SortById ?? 0);
            return (a.Name ?? '').localeCompare(b.Name ?? '');
        });;
        // Assign SortById and sortkey to non-archived
        nonArchived.forEach((item, idx) => {
            item.SortById = idx + 1;
            item.sortkey = '0-' + String(item.SortById).padStart(4, '0');
        });
        // Assign SortById (starting after all the non-archived) and sortkey to archived
        archived.forEach((item, idx) => {
            item.SortById = nonArchived.length + idx + 1;
            item.sortkey = '1-' + String(item.Name ?? '').toLowerCase();
        });
        this.manageModalData = [...nonArchived, ...archived];
    }

    private initModalHandlers() {
        // Save functionality for add new item modal
        $('#savePicklistItemBtn').on('click', (e) => {
            e.preventDefault();
            if (!this.validateForm()) {
                return;
            }
            const picklistType = $('#picklistType').val() as string;
            const id = Number($('#picklistItemId').val()) || 0;
            const name = $('#picklistItemName').val() as string;
            let timeSpanInDays = null;
            let isStartupEssential = null;
            let isChecklistItem = null;
            let milestoneCategory = null;
            let milestoneDescription = null;
            if (picklistType === 'milestones') {
                const timeSpan = $('#picklistItemTimeSpanInDays').val();
                timeSpanInDays = timeSpan !== undefined && timeSpan !== null && timeSpan !== '' ? Number(timeSpan) : null;
                isStartupEssential = $('#picklistItemIsStartupEssential').is(':checked');
                isChecklistItem = $('#picklistItemIsChecklistItem').is(':checked');
                milestoneCategory = $('#picklistItemMilestoneCategory').val();
                milestoneDescription = $('#picklistItemMilestoneDescription').val();
            }
            var sortById = null;
            if (id === 0) {
                const nonArchived = this.picklistMap[picklistType].data.filter(item => !item.IsArchived);
                const maxSortById = nonArchived.length > 0 ? nonArchived.length : 0;
                sortById = maxSortById + 1;
            }
            // For deliverableStatuses, get DeliverableId
            var deliverableId = null;
            if (picklistType === 'deliverableStatuses') {
                deliverableId = $('#picklistItemDeliverableId').val();
            }
            $.ajax({
                url: '/secure/ctms/settings/settings?handler=SavePicklistItem',
                method: 'POST',
                headers: { "RequestVerificationToken": this.token },
                data: {
                    PicklistType: picklistType,
                    Id: id,
                    Name: name,
                    TimeSpanInDays: picklistType === 'milestones' ? timeSpanInDays : (this.picklistMap[picklistType].timeSpan ? timeSpanInDays : null),
                    IsStartupEssential: picklistType === 'milestones' ? isStartupEssential : null,
                    IsChecklistItem: picklistType === 'milestones' ? isChecklistItem : null,
                    Category: picklistType === 'milestones' ? milestoneCategory : null,
                    Description: picklistType === 'milestones' ? milestoneDescription : null,
                    SortById: sortById,
                    DeliverableId: deliverableId
                },
                success: (resp) => {
                    if (resp && resp.success && Array.isArray(resp.items)) {
                        this.refreshTable(picklistType, resp.items);
                        $('#picklistItemModal').modal('hide');
                    } else {
                        alert('Error saving item.');
                    }
                },
                error: () => {
                    alert('Error saving item.');
                }
            });
        });
        // Reset modal on close
        $('#picklistItemModal').on('hidden.bs.modal', () => {
            $('#picklistItemId').val('');
            $('#picklistType').val('');
            $('#picklistItemName').val('');
            $('#picklistItemTimeSpanInDays').val(null);
            $('.picklistItemMilestoneGroup').hide();
            const validationError = document.getElementById('picklist-validation-error');
            validationError.classList.add('d-none');
        });
        $('#picklistItemModal').modal({
            backdrop: 'static',
            show: false
        });
        // Save functionality for manage items modal
        $('#saveManagePicklistItemsBtn').off('click').on('click', (e) => {
            $('#saveManagePicklistItemsBtn').prop('disabled', true);
            $('#managePicklistItemsSaveSpinner').show();
            $.ajax({
                url: '/secure/ctms/settings/settings?handler=SavePicklistOrderAndArchive',
                method: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    PicklistType: this.manageModalPicklistType,
                    Items: this.manageModalData
                }),
                headers: { "RequestVerificationToken": this.token },
                success: (resp) => {
                    if (resp && resp.success && Array.isArray(resp.items)) {
                        this.refreshTable(this.manageModalPicklistType, resp.items);
                        $('#managePicklistItemsModal').modal('hide');
                    } else {
                        alert('Error saving items.');
                    }
                },
                error: () => {
                    alert('Error saving items.');
                },
                complete: () => {
                    $('#saveManagePicklistItemsBtn').prop('disabled', false);
                    $('#managePicklistItemsSaveSpinner').hide();
                }
            });
        });

        $('#managePicklistItemsModal').on('shown.bs.modal', () => {
            if (this.manageModalTable) {
                this.manageModalTable.columns.adjust();
            }
        });
    }

    validateForm(): boolean {
        const picklistItemName = $('#picklistItemName').val();
        var valid = true;
        if (!picklistItemName || picklistItemName.toString().trim() === '') {
            $('#picklist-validation-error').removeClass('d-none');
            valid = false;
        }
        return valid;
    }

    private openModal(picklistType: string, rowData: any) {
        $('#picklistType').val(picklistType);
        // Deliverable dropdown logic for deliverableStatuses
        if (picklistType === 'deliverableStatuses') {
            // Populate dropdown
            const deliverables = this.picklistMap['deliverables']?.data || [];
            const $dropdown = $('#picklistItemDeliverableId');
            $dropdown.empty();
            deliverables.forEach(d => {
                $dropdown.append(`<option value="${d.Id}">${d.Name}</option>`);
            });
            $('#picklistItemDeliverableGroup').show();
            // Set value if editing
            if (rowData && rowData.DeliverableId) {
                $dropdown.val(rowData.DeliverableId);
            } else {
                $dropdown.val('');
            }
        } else {
            $('#picklistItemDeliverableGroup').hide();
        }

        // Conditional hide/show for milestone fields
        if (picklistType === 'milestones') {
            if (rowData) {
                $('#picklistItemTimeSpanInDays').val(rowData.TimeSpanInDays || null);
                $('#picklistItemIsStartupEssential').prop('checked', !!rowData.IsStartupEssential);
                $('#picklistItemIsChecklistItem').prop('checked', !!rowData.IsChecklistItem);
                $('#picklistItemMilestoneCategory').val(rowData.Category || '');
                $('#picklistItemMilestoneDescription').val(rowData.Description || '');
            } else {
                $('#picklistItemTimeSpanInDays').val(null);
                $('#picklistItemIsStartupEssential').prop('checked', false);
                $('#picklistItemIsChecklistItem').prop('checked', false);
                $('#picklistItemMilestoneCategory').val('');
                $('#picklistItemMilestoneDescription').val('');
            }
            $('.picklistItemMilestoneGroup').show();
        } else {
            $('.picklistItemMilestoneGroup').hide();
        }

        if (rowData) {
            $('#picklistItemId').val(rowData.Id);
            $('#picklistItemName').val(rowData.Name);
            $('#picklistItemModalLabel').text('Edit Item');
        } else {
            $('#picklistItemId').val('');
            $('#picklistItemName').val('');
            $('#picklistItemModalLabel').text('Add New Item');
        }
        $('#picklistItemModal').modal('show');
    }

    private refreshTable(picklistType: string, items: any[]) {
        const tableId = this.picklistMap[picklistType].tableId;
        const table = $(tableId).DataTable();
        this.picklistMap[picklistType].data = mapKeysToPascalCase(items) || [];
        const nonArchivedData = this.picklistMap[picklistType].data.filter(item => !item.IsArchived);
        table.clear();
        table.rows.add(nonArchivedData).draw();
    }
}

function mapKeysToPascalCase(obj: any): any {
    if (Array.isArray(obj)) {
        return obj.map(mapKeysToPascalCase);
    }
    if (obj !== null && typeof obj === 'object') {
        const newObj: any = {};
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
                newObj[pascalKey] = mapKeysToPascalCase(obj[key]);
            }
        }
        return newObj;
    }
    return obj;
}
